<template>
  <div :class="['cf-menu-page-header', { 'cf-padding-top-12': !hasBannerImage }]">
    <template v-if="bannerContent.bannerUrl && hasBannerImage">
      <a :href="bannerContent.bannerUrl">
        <img
          class="cf-image cf-image--banner"
          :alt="merchant.name"
          :src="bannerContent.bannerImage"
          onerror="this.src='/images/image-not-found.png';"
        >
      </a>
    </template>
    <template v-else-if="hasBannerImage">
      <img
        class="cf-image cf-image--banner"
        :alt="merchant.name"
        :src="bannerContent.bannerImage"
        onerror="this.src='/images/image-not-found.png';"
      >
    </template>

    <div class="cf-menu-page-header-details">
      <div class="cf-menu-page-header-details__left">
        <h2
          v-if="bannerContent.title"
          class="cf-title cf-title--2"
        >
          {{ bannerContent.title }}
        </h2>

        <cf-order-address-details />
      </div>

      <div class="cf-menu-page-header-details__right">
        <button
          v-if="isLocationDetailsEnabled"
          title="View store details"
          type="button"
          class="cf-button cf-button--tertiary cf-button--md cf-button--expand-md"
          @click="openLocationDetailsHandler"
        >
          <span class="cf-icon far fa-info-circle" />

          Store Details
        </button>

        <router-link
          v-if="giftCardGiftingEnabled"
          v-tippy="{
            content: sendGiftCardContent,
            onShow: () => showSendGiftCardContentTooltip
          }"
          class="cf-button cf-button--tertiary cf-button--md cf-button--expand-md"
          :to="{ name: 'orderGifting' }"
        >
          <span class="no-wrap-ellipsis">
            {{ sendGiftCardContent }}
          </span>
        </router-link>

        <button
          v-if="isGroupOrderEnabled"
          class="cf-button cf-button--tertiary cf-button--md cf-button--expand-md"
          :title="groupOrderButtonContent"
          type="button"
          @click="openGroupOrderHandler"
        >
          <span class="cf-icon far fa-users" />

          Group Order
        </button>
      </div>
    </div>
  </div>
</template>


<script>
  import { mapGetters } from 'vuex';

  import CfOrderAddressDetails from './cf-order-address-details/index.vue';


  export default {
    name: 'CfMerchantInfoAndBanner',

    components: {
      CfOrderAddressDetails
    },

    computed: {
      ...mapGetters('content', ['content']),
      ...mapGetters('giftCards', ['giftCardGiftingEnabled', 'giftCardManagementEnabled']),
      ...mapGetters('locations', ['selectedLocation']),
      ...mapGetters('merchant', ['merchant']),
      ...mapGetters('menu', ['menu']),
      ...mapGetters('orders', ['order', 'showGroupOrderButton']),
      ...mapGetters('session', ['orderDetails']),

      bannerContent() {
        /** Note: Standard is a catch all for non-catering orders, see: session store */
        const isStandardOrderType = this.orderDetails.orderType === 'standard';

        const content = this.content.MenuBanner;

        const bannerImage = isStandardOrderType ? content?.metadata?.webImageUrl : content?.metadata?.cateringMenuBannerImageUrl;

        const bannerUrl = isStandardOrderType ? content?.metadata?.webMenuBannerTargetUrl : content?.metadata?.cateringMenuBannerTargetUrl;

        return {
          bannerImage,
          bannerUrl,
          title: content?.metadata?.menuBannerDescription
        };
      },

      sendGiftCardContent() {
        return this.content.MenuDropdown.metadata?.itemSendAGiftCard;
      },

      hasBannerImage() {
        return this.bannerContent.bannerImage;
      },

      isLocationDetailsEnabled() {
        return this.merchant.options.locationChangeEnabled && this.selectedLocation.storeId;
      },

      isGroupOrderEnabled() {
        return this.showGroupOrderButton;
      },

      groupOrderButtonContent() {
        return this.orderDetails.orderType === 'group' ? 'Edit your group order' : 'Start a group order';
      },

      showSendGiftCardContentTooltip() {
        return this.sendGiftCardContent.length > 20;
      }
    },

    methods: {
      openLocationDetailsHandler() {
        this.$openModal('locationDetails', { location: this.selectedLocation });
      },

      openGroupOrderHandler() {
        this.$openModal('editGroupOrder');
      }
    }
  };
</script>
